import * as navigation from 'Navigation';

export default class ProcedureTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Procedure',
      closeable: false,
      preferenceKey: 'procedure',
    };
  }
}
